/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Session_CheckingInputs */

const en_auth_session_checking = /** @type {(inputs: Auth_Session_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking your session...`)
};

const pl_auth_session_checking = /** @type {(inputs: Auth_Session_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdzanie sesji...`)
};

/**
* | output |
* | --- |
* | "Checking your session..." |
*
* @param {Auth_Session_CheckingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_session_checking = /** @type {((inputs?: Auth_Session_CheckingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Session_CheckingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_session_checking(inputs)
	return en_auth_session_checking(inputs)
});